<template>
  <div>
    <div class="bg-kplh-primary text-white">
      FORMULIR PRAKUALIFIKASI SISTEM MANAJEMEN KESELAMATAN PERTAMBANGAN DAN
      LINGKUNGAN HIDUP (KRITERIA RISIKO
      {{ kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-') }})
    </div>
    <div class="mb10">
      No. formulir: FRM-014-001-{{
        kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-')[0]
      }}
    </div>
    <div class="flex flex-row mb10">
      <table class="col-7 text-sm">
        <tr class="bg-kplh-second text-white" style="height: 20px">
          PETUNJUK PENGISIAN BAGI CALON VENDOR / KONTRAKTOR
        </tr>
        <tr>
          1. Formulir ini terdiri dari 13
          <strong>Persyaratan</strong>
          (A s/d M) dan setiap Persyaratan memiliki
          <strong>Bobot</strong>
          tersendiri.
        </tr>
        <tr>
          2. Calon Vendor / Kontraktor melampirkan salinan dokumen yang diminta
          dalam setiap persyaratan.
        </tr>
        <tr>
          3. Salinan dokumen dilampirkan terpisah pada Dokumen Lampiran.
          <strong>Dokumen Lampiran</strong>
          harus memuat
          <strong>Daftar Isi Lampiran</strong>
          beserta penomoran pada setiap Lampiran untuk memudahkan pelacakan saat
          dilakukan penilaian.
        </tr>
        <tr>
          4. Kolom Nilai dan kolom Penjelasan Hasil Penilaian diisi oleh Tim
          Penilai GEMS.
        </tr>
      </table>

      <table class="col-5 text-sm">
        <tr class="bg-kplh-second text-white" style="height: 20px">
          PETUNJUK PENGISIAN BAGI TIM PENILAI
        </tr>
        <tr>
          N/A: Tidak diperlukan
        </tr>
        <tr>
          0: Tidak ada / tidak tersedia / tidak dijelaskan
        </tr>
        <tr>
          1: Persyaratan belum terpenuhi
        </tr>
        <tr>
          2: Persyaratan cukup memadai tetapi perlu perbaikan
        </tr>
        <tr>
          3: Persyaratan sudah memadai
        </tr>
      </table>
    </div>
    <div class="mb10">
      <table class="w-100">
        <tr>
          <td colspan="3" class="bg-kplh-second text-white">
            Informasi Perusahaan
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">1</td>
          <td class="col-6 bg-kplh-third">Nama Perusahaan</td>
          <td class="col-5">{{ kplh && $get(kplh, 'nama_vendor') }}</td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">2</td>
          <td class="col-6 bg-kplh-third">Alamat Perusahaan</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.vendor.alamat') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">3</td>
          <td class="col-6 bg-kplh-third">Jenis Badan Usaha</td>
          <td class="col-5">
            {{ kplh ? $get(kplh, 'request.vendor.badan_usaha.desc') : '' }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">4</td>
          <td class="col-6 bg-kplh-third">Bidang Usaha / Jenis Pekerjaan</td>
          <td class="col-5">
            <!-- {{ bidang_usaha_gems && bidang_usaha_gems.join(',') }} -->
            <div v-if="bidang_usaha_gems && bidang_usaha_gems.length > 0">
              <p v-for="(list, index) in bidang_usaha_gems" :key="index"
                style="list-style-type: decimal; border-bottom: none; margin-bottom: .3rem !important">
                {{ index + 1 }}. {{ list }}
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">5</td>
          <td class="col-6 bg-kplh-third">
            Penanggung Jawab Operasional (PJO) / Person In Charge (PIC)
          </td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_name') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">6</td>
          <td class="col-6 bg-kplh-third">
            Posisi PJO / PIC dalam Struktur Organisasi Perusahaan
          </td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_position') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">7</td>
          <td class="col-6 bg-kplh-third">Email PJO / PIC</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_email') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">8</td>
          <td class="col-6 bg-kplh-third">Nomor Kontak PJO / PIC</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_phone') }}
          </td>
        </tr>
      </table>
    </div>
    <kplh-template-kritis v-if="
      kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-') == '-'
    " :kplh="kplh" :finalResult="finalResult" :totalResult="totalResult" :penilaian="penilaian" :bobot="bobot"
      :totalNilai="totalNilai" />
    <kplh-template-kritis v-if="
      kplh &&
      $get(
        kplh,
        'request.kplh_penilaian.tingkat_resiko',
        '-'
      ).toUpperCase() == 'KRITIS'
    " :kplh="kplh" :finalResult="finalResult" :totalResult="totalResult" :penilaian="penilaian" :bobot="bobot"
      :totalNilai="totalNilai" />
    <kplh-template-tinggi v-if="
      kplh &&
      $get(
        kplh,
        'request.kplh_penilaian.tingkat_resiko',
        '-'
      ).toUpperCase() == 'TINGGI'
    " :kplh="kplh" :finalResult="finalResult" :totalResult="totalResult" :penilaian="penilaian" :bobot="bobot"
      :totalNilai="totalNilai" />
    <kplh-template-sedang v-if="
      kplh &&
      $get(
        kplh,
        'request.kplh_penilaian.tingkat_resiko',
        '-'
      ).toUpperCase() == 'SEDANG'
    " :kplh="kplh" :finalResult="finalResult" :totalResult="totalResult" :penilaian="penilaian" :bobot="bobot"
      :totalNilai="totalNilai" />
    <kplh-template-rendah v-if="
      kplh &&
      $get(
        kplh,
        'request.kplh_penilaian.tingkat_resiko',
        '-'
      ).toUpperCase() == 'RENDAH'
    " :kplh="kplh" :finalResult="finalResult" :totalResult="totalResult" :penilaian="penilaian" :bobot="bobot"
      :totalNilai="totalNilai" />
    <div class="flex flex-row">
      <div class="w-50 h-auto flex-center">
        <img :src="newQRCode" alt="QRCode" v-if="qr_active" />
      </div>
      <kplh-approver :kplh="kplh" />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { api, api_lp } from '@/services/config'
import QRious from 'qrious'
export default {
  props: ['qr_active', 'kplh', 'penilaian', 'kbli', 'bidang_usaha_gems'],
  components: {
    kplhApprover: () => import('./kplh-approver.vue'),
    kplhTemplateKritis: () => import('./kplh-template-kritis.vue'),
    kplhTemplateTinggi: () => import('./kplh-template-tinggi.vue'),
    kplhTemplateSedang: () => import('./kplh-template-sedang.vue'),
    kplhTemplateRendah: () => import('./kplh-template-rendah.vue'),
  },
  data() {
    return {
      qrcode: new QRious({ size: 300 }),
      tableResiko: {
        kritis: 159,
        tinggi: 122,
        sedang: 41,
        rendah: 12,
      },
    }
  },
  async created() {
  },
  computed: {
    totalResult() {
      const total =
        this.kplh &&
        this.$get(this.kplh, 'request.kplh_penilaian.total_result', 0)
      if (total) {
        return Number(total).toFixed(2)
      }

      return 0
    },
    finalResult() {
      const result =
        this.kplh &&
        this.$get(this.kplh, 'request.kplh_penilaian.final_result', '-')

      return result
    },
    newQRCode() {
      this.qrcode.value = `${process.env.VUE_APP_ISUPPLIER_URL
        }pdf/kplh-document/${this.$route.params.id}/${this.kplh &&
        this.$get(this.kplh, 'nama_vendor', '-')}`
      return this.qrcode.toDataURL()
    },
    bobot() {
      let bobot = 0
      const tingkatResiko =
        this.kplh &&
        this.$get(
          this.kplh,
          'request.kplh_penilaian.tingkat_resiko',
          '-'
        ).toLowerCase()
      if (tingkatResiko == 'kritis') bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko == 'tinggi') bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko == 'sedang') bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko == 'rendah') bobot = this.tableResiko[tingkatResiko]


      return bobot
    },
    totalNilai() {
      let total = 0

      const is_hse_head = this.$route.path.indexOf('kplh-validation-head') != -1
      const is_ktt = this.$route.path.indexOf('kplh-validation-hse-ktt') != -1
      const is_pdf = this.$route.path.indexOf('/kplh-document/') != -1

      if (is_hse_head || is_ktt || is_pdf) {
        if (this.totalResult && this.totalResult != 0) {
          // total = (Number(this.totalResult) * Number(this.bobot)) / 100
          total = Number(this.totalResult)
        }

        // return total.toFixed(2)
        return total
      }
      return Number(this.totalResult)
      // return 0
    },
  },
  methods: {

  },
}
</script>
